// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + ".legacy." + {"2897":"3c3da1a4d542510798e2","3490":"6867a60f2801c6d1b6af"}[chunkId] + ".js";
};